import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bizCount',
})
export class BizCountPipe implements PipeTransform {
  transform(attendee: any[]): any {
    return attendee.filter((obj) => {
      if (obj.role) {
        if (obj.role === 'B' && obj.is_staff) {
          return obj;
        }
      }
    });
  }
}
